/**
 * Quick-Create Node Schema (Slice 3.2)
 *
 * The 3-field zod schema for the inline quick-create flow (Slice 3.3) — the
 * name-first (中文 → EN → Code) minimal create surface. Messages resolve
 * through `taxonomy:validation.*` (localized via `t()`), matching the in-file
 * schema in `CreateNodeModal` exactly so both surfaces validate identically.
 *
 * The shared SUBMIT path (createNode + CODE_TAKEN guard-UX) lives in
 * `useInlineCreateNode()` — this schema owns only the client-side field rules.
 */

import { z } from 'zod';

export const quickCreateNodeSchema = z.object({
  nameZh: z.string().trim().min(1, 'taxonomy:validation.nameZhRequired'),
  nameEn: z.string().trim().min(1, 'taxonomy:validation.nameEnRequired'),
  code: z.string().trim().min(1, 'taxonomy:validation.codeRequired'),
});

export type QuickCreateNodeFormData = z.infer<typeof quickCreateNodeSchema>;
